import styled from '@emotion/styled';
import { Link } from '~/shared/components/Link';

export const EUGaranModalWrapper = styled.div(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
    gap: theme.space[4],
    paddingLeft: theme.space[3],
    paddingRight: theme.space[3],
    paddingTop: theme.space[3],
}));

export const LabelWrapper = styled.div({
    width: '100%',
    maxWidth: '100%',

    img: {
        display: 'block',
        width: '100%',
        height: 'auto',
    },
});

export const TextLink = styled(Link)(({ theme }) => ({
    color: theme.colors.nightBlack,
    fontSize: theme.fontSizes.mouse,
}));
